var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProblemSolvingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 19.09H11.25C10.5873 19.09 10.05 19.6273 10.05 20.29C10.05 20.9528 10.5873 21.49 11.25 21.49H12.66C13.3228 21.49 13.86 20.9528 13.86 20.29C13.86 19.6273 13.3228 19.09 12.66 19.09Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.12 17.89C15.12 18.55 14.59 19.08 13.93 19.08H9.98004C9.32004 19.08 8.79004 18.55 8.79004 17.89C8.79004 17.23 9.32004 16.69 9.98004 16.69H13.93C14.59 16.69 15.12 17.23 15.12 17.89Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.73 13.25C14.94 13.87 14.41 14.74 14.13 15.7L13.85 16.68H10.05L9.73998 15.6C9.46998 14.65 8.91998 13.79 8.15998 13.16C6.82998 12.05 5.97998 10.38 5.97998 8.52C5.97998 4.78 9.38998 1.84 13.27 2.64C15.5 3.1 17.32 4.85 17.84 7.06C18.43 9.55 17.47 11.87 15.73 13.24V13.25Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37988 8.28997L11.3099 10.22L14.6199 6.90997",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblemSolvingIcon);
export default __webpack_public_path__ + "static/media/problem_solving_icon.4e46829eaf7a1df67ea04c2557a46a6f.svg";
export { ForwardRef as ReactComponent };